module.exports = __webpack_public_path__ + "static/cloud-min-1db01b9def5dcb333a8b4ba2e09b3817.jpg";